// 한국 전용 서비스 - 모든 시각을 KST(Asia/Seoul)로 고정 표시.
// 서버는 UTC ISO(...Z)로 내려주므로 표시 시점에 KST로 변환한다.
const KST = 'Asia/Seoul';

/** YYYY. MM. DD. HH:MM (KST) */
export function formatKstDateTime(v?: string | null): string {
  if (!v) return '-';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleString('ko-KR', {
    timeZone: KST,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  });
}

/** YYYY. MM. DD. (KST) */
export function formatKstDate(v?: string | null): string {
  if (!v) return '-';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('ko-KR', {
    timeZone: KST,
    year: 'numeric', month: '2-digit', day: '2-digit',
  });
}
